export default __webpack_public_path__ + "static/media/rocket_anim_143.7b5af85e.png";